import { render } from "./Sanchan2.vue?vue&type=template&id=c6f06b2e&scoped=true"
import script from "./Sanchan2.vue?vue&type=script&lang=js"
export * from "./Sanchan2.vue?vue&type=script&lang=js"

import "./Sanchan2.vue?vue&type=style&index=0&id=c6f06b2e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c6f06b2e"

export default script